import { useEffect, useRef } from 'react'
/**
 * The service's reel in the detail block (spec §4.3): poster in the markup, the clip only
 * once the box is on screen (IntersectionObserver), paused when it leaves; never loaded
 * under prefers-reduced-motion (the poster stays). Muted, looping, no controls.
 */
export function ReelVideo({ src, poster, label }: { src: string; poster: string; label: string }) {
  const ref = useRef<HTMLVideoElement>(null)
  useEffect(() => {
    const v = ref.current
    if (!v || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
    const io = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) {
        if (!v.src) v.src = src
        v.play().catch(() => {})
      } else v.pause()
    }, { threshold: 0.25 })
    io.observe(v)
    return () => io.disconnect()
  }, [src])
  return (
    <video ref={ref} poster={poster} muted loop playsInline preload="none" aria-label={label} disablePictureInPicture
      className="h-full w-full object-cover" />
  )
}
